// extracted by mini-css-extract-plugin
module.exports = {"title":"SupportModal_title__17c4V","subTitle":"SupportModal_subTitle__3KEeZ","headerIcon":"SupportModal_headerIcon__2zyQ4"};